import { Component, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { PageKind, UiModeType, } from 'jk-service';
import { StktmService, templateUrlConfigStk } from './../_service_stk';
//import { Stkpi19DetailComponent } from './stkpi19-detailPkg.component';
import { StktmEditComponent, } from './../_edit_stk';
import { AdvComModule, jkSingleComponent, } from 'jk-advcom';


@Component({
  selector: 'app-stkpi19',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    //Stkpi19DetailComponent,
    AdvComModule,
  ],
  templateUrl: templateUrlConfigStk.stkpi19,
  styleUrls: [],
})
export class Stkpi19PkgComponent extends jkSingleComponent implements OnInit {
  override _programId = 'stkpi19';
  constructor() {
    super();
    this.srv = new StktmService();
    this.uiMode = UiModeType.dialog;
    this.title = '追蹤股票建立';
    this.gridInitOpt = { programId: this.programId, sortField: 'TM002', sort: 'asc', defaultSort: null, pageKind: PageKind.bill };
    this.qbeConfig.addField = 'TM002,TM003,TM012,TM014,TM120';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = StktmEditComponent;

    //this.addOpenwinLoadOption('STKMA', 'W01', 'W', [], this.stkmaList);

    this.constructorInit();
  }

  /*
  override getLookup() {
    super.getLookup();
  }

  override constructorInit() {
    super.constructorInit();
  }
  */


}
